import pin from "./pin";
import cash from "./cash";
import giftcard from "./giftcard";

export default {
    pin,
    cash,
    giftcard
}